import { useTradingStyle } from "@/contexts/TradingStyleContext";
import { LineChart, Zap } from "lucide-react";

export default function StyleToggle() {
  const { style, setStyle } = useTradingStyle();
  const items = [
    { key: "SWING", label: "Swing", icon: LineChart },
    { key: "INTRADAY", label: "Intraday", icon: Zap },
  ];
  return (
    <div
      data-testid="style-toggle"
      className="flex items-center border border-[#1E293B] bg-[#0B111C]"
      role="tablist"
      aria-label="Trading style"
    >
      {items.map(({ key, label, icon: Icon }) => {
        const active = style === key;
        return (
          <button
            key={key}
            role="tab"
            aria-selected={active}
            data-testid={`style-toggle-${key.toLowerCase()}`}
            onClick={() => setStyle(key)}
            className={`mono text-[11px] uppercase tracking-widest px-2.5 h-8 flex items-center gap-1.5 transition-colors ${
              active
                ? key === "INTRADAY"
                  ? "bg-amber-500/15 text-amber-200 border-l border-r border-amber-500/50"
                  : "bg-cyan-500/15 text-cyan-200 border-l border-r border-cyan-500/50"
                : "text-slate-500 hover:text-slate-200"
            }`}
          >
            <Icon className="h-3 w-3" />
            {label}
          </button>
        );
      })}
    </div>
  );
}
